/**
 * Every name the lead page calls itself, and where it lives, in one place.
 *
 * The page is the OSR tab of Sales Intake — the first tab (it was the OSR
 * tab of Poseidon Live until Sep 30 2026; "OSR" is the team's word for a
 * lead, Allen's call, so the name came with it). If it ever moves again,
 * this is the file that changes: the words, and the one path. Nothing else
 * in components/osr/ spells either out.
 */

export const OSR_WORDING = {
  short: "OSR",
  title: "OSR",
  subtitle: "Leads from the website and from the team. Claim one, call them, close it.",
  board: "the OSR tab",
  openBoard: "Open OSR",
  submitted: "Lead submitted. It is on the OSR tab.",
};

// Where the page is mounted. `?lead=<id>` opens that lead's panel.
export const OSR_PATH = "/app/sales-intake/osr";
export const leadLink = (id) => (id ? `${OSR_PATH}?lead=${encodeURIComponent(id)}` : OSR_PATH);

// Sales Sheets: a captured sheet opens expanded, an uncaptured one is a card
// in the queue and can only be reached by opening the page.
export const salesSheetLink = (id, status) =>
  id && status === "captured" ? `/app/sales-submissions?open=${encodeURIComponent(id)}` : "/app/sales-submissions";
